import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'loader-detail',
    templateUrl: './loader-detail.component.html',
    styleUrls: ['./loader-detail.component.scss'],
    standalone: true,
})
export class LoaderDetailComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
